import { render, staticRenderFns } from "./UserChat.vue?vue&type=template&id=ab250946"
import script from "./UserChat.vue?vue&type=script&lang=js"
export * from "./UserChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports